import React from 'react';

const FinishTickDynamica = () => {
  return (
    <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M60 15.5c24.534 0 44.5 19.966 44.5 44.5S84.534 104.5 60 104.5 15.5 84.534 15.5 60 35.466 15.5 60 15.5z'
        stroke='#FFD031'
        strokeWidth='7'
      />
      <path d='M37 57.267 54.837 75 83 47' stroke='#000' strokeWidth='5' strokeLinecap='square' />
    </svg>
  );
};

export default FinishTickDynamica;
